<template>
	<div class="login-page">
		<img src="@/assets/image/logo.png" class="absolute top-[80px] left-[100px] w-[380px] h-[80px]"></img>

		<div class="login-container">
			<div class="login-title">账号登录
				<div style="width: 119px;height: 4px;background: #C51819;border-radius: 1px;margin:0 auto"></div>
			</div>
			<div class="login-field">
				<input v-model="username" class="login-field-value" placeholder="账号：" autocomplete="new-password" type="text" />
			</div>
			<div class="login-field">
				<input v-model="password" class="login-field-value" placeholder="密码：" autocomplete="new-password"
					type="password" />
			</div>
			<div class="login-checkbox" @click="save = !save">
				<div class="w-[24px] h-[24px] rounded-full border border-solid border-gray text-center" :style="{
					background: save ? 'linear-gradient(90deg, #BE1817, #C51819)' : 'transparent',
					'border-color': save ? 'transparent' : 'gray',
				}">
					<i class="fa fa-check text-white"></i>
				</div>
				<!-- <img v-show="!save" class="login-checkbox-icon" src="~@/assets/image/5.png" alt="" /> -->
				<!-- <img v-show="save" class="login-checkbox-icon" src="~@/assets/image/6.png" alt="" /> -->
				<div class="login-checkbox-text">记住密码</div>
			</div>
			<div class="login-button" @click="onLogin">登录</div>
		</div>
	</div>
</template>

<script>
import { post } from "@/assets/js/http.js"

export default {
	name: "view-login",
	data() {
		return {
			save: false,
			username: "",
			password: "",
		}
	},
	mounted() {
		this.save = localStorage.getItem("save") === "true"
		if (this.save) {
			this.username = localStorage.getItem("username")
			this.password = localStorage.getItem("password")
		} else {
			this.username = ""
			this.password = ""
		}
	},
	methods: {
		async onLogin() {
			if (this.username && this.password) {
				localStorage.setItem("save", this.save)
				if (this.save) {
					localStorage.setItem("username", this.username)
					localStorage.setItem("password", this.password)
				} else {
					localStorage.removeItem("username")
					localStorage.removeItem("password")
				}
				const data = await post({
					url: "/admin/index/login",
					loading: true,
					successTip: true,
					data: {
						username: this.username,
						password: this.password,
					},
				})
				this.$store.commit("login", data.userinfo)
				this.$router.replace("/")
			} else {
				this.$message.error("用户名和密码不能为空")
			}
		},
	},
}
</script>
